<template>
  <div>
    <div class="pt-3 mt-3 text-center data-notice">
      <b-row class="text-left mb-3 w-100">
        <b-col cols="12" class="ml-3">
          <b v-if="isDownloadNotice">
            The data you are downloading is owned by FI Navigator Corporation,
            is a component of Licensed Materials, and is Confidential
            Information. You may only use, store, and distribute the data
            according to your Agreement.
          </b>
          <b v-else>
            The services and data are owned by FI Navigator Corporation, are a
            component of Licensed Materials, and are Confidential Information.
            You may only use, store, and distribute the data according to your
            Agreement.
          </b>
        </b-col>
      </b-row>
      <b-row
        class="justify-content-center w-100"
        cols="1"
        cols-sm="2"
        cols-md="3"
      >
        <b-col>
          <span
            ><img
              src="../../../../static/img/ai.png"
              alt=""
              class="img-fluid pr-1"
          /></span>
          <h6><b>No AI/Machine Learning</b></h6>
        </b-col>
        <b-col>
          <span
            ><img
              src="../../../../static/img/resell.png"
              alt=""
              class="img-fluid pr-1"
          /></span>
          <h6><b>No Resell, Redistribution, or Derivatives</b></h6>
        </b-col>
        <b-col>
          <span
            ><img
              src="../../../../static/img/crm.png"
              alt=""
              class="img-fluid pr-1"
          /></span>
          <h6><b>No CRM without a License</b></h6>
        </b-col>
        <b-col>
          <span
            ><img
              src="../../../../static/img/term.png"
              alt=""
              class="img-fluid pr-1"
          /></span>
          <h6><b>No Data Retention after Termination</b></h6>
        </b-col>
        <b-col>
          <span
            ><img
              src="../../../../static/img/3rdparty.png"
              alt=""
              class="img-fluid pr-1"
          /></span>
          <h6><b>No 3rd-Party Users without Approval</b></h6>
        </b-col>
        <b-col>
          <span
            ><img
              src="../../../../static/img/reverse.png"
              alt=""
              class="img-fluid pr-1"
          /></span>
          <h6><b>No Reverse Engineering</b></h6>
        </b-col>
      </b-row>
    </div>
    <div class="py-3 text-center " v-if="showIAccept">
      <b-form-checkbox id="terms" v-model="terms" @change="toggle">
        I accept the terms of the Agreement
      </b-form-checkbox>
    </div>
  </div>
</template>
<script>
export default {
  name: 'DataDownloadNotice',
  props: {
    isDownloadNotice: {
      type: Boolean,
      default: true
    },
    showIAccept: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      terms: false
    }
  },
  methods: {
    toggle(checked) {
      this.terms = checked
      this.$emit('updateTerms', this.terms)
    }
  }
}
</script>

<style lang="scss" scoped>
.data-notice {
  background-color: #e9f3f9;
  .img-fluid {
    max-width: 50%;
    height: auto;
  }
}
</style>
